import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M12.9398 0.48999C11.4398 2.02999 10.0197 3.66003 8.84973 5.41003C8.25973 6.28003 7.71973 7.19 7.34973 8.12C6.96973 9.04 6.82974 10.0199 6.72974 11.0699C6.51974 13.1599 6.63973 15.39 5.90973 17.59C5.53973 18.68 5.04977 19.7899 4.19977 20.6899C3.36977 21.5999 2.13977 22.14 1.00977 22.08L0.969727 21.88C2.97973 20.89 3.59976 19.05 3.99976 17.08L5.13977 10.83C5.33977 9.75996 5.60973 8.60006 6.15973 7.56006C6.68973 6.54006 7.34974 5.63003 8.04974 4.78003C9.49974 3.12003 11.0898 1.62995 12.8198 0.319946L12.9398 0.48999Z"
        fill={outline}
      />
      <path
        d="M24.3895 0.339966C26.1195 1.64997 27.7095 3.14005 29.1595 4.80005C29.8595 5.65005 30.5195 6.54996 31.0495 7.57996C31.5995 8.61996 31.8695 9.77998 32.0695 10.85L33.2095 17.1C33.6095 19.07 34.2295 20.91 36.2395 21.9L36.1995 22.1C35.0695 22.16 33.8395 21.62 33.0095 20.71C32.1495 19.81 31.6595 18.7 31.2995 17.61C30.5695 15.41 30.6895 13.18 30.4795 11.09C30.3795 10.03 30.2395 9.05001 29.8595 8.14001C29.4895 7.21001 28.9495 6.30005 28.3595 5.43005C27.1795 3.67005 25.7595 2.05001 24.2695 0.51001L24.3895 0.339966Z"
        fill={outline}
      />
    </g>
  )
}
